import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/vhosts/restroai.de/httpdocs/src/client/components/ui/ClientToaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/var/www/vhosts/restroai.de/httpdocs/src/client/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/var/www/vhosts/restroai.de/httpdocs/src/client/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/var/www/vhosts/restroai.de/httpdocs/src/styles/tailwind.css");
